import { useQuery } from 'react-query';
import getSales from 'data/requests/getSales';
import { Sales } from 'model/sales';

type Props = {
  brandId: string;
  dateStart: String;
  dateEnd: string;
};

const useSales = ({ brandId, dateStart, dateEnd }: Props) => {
  const { data, isLoading, refetch } = useQuery<Sales>(
    [
      'sales',
      {
        brandId,
        dateStart,
        dateEnd,
      },
    ],
    () => getSales({ brandId, dateStart, dateEnd }),
    {
      enabled: false,
    },
  );
  return { sales: data, isLoading, refetch };
};

export default useSales;
